import * as Redux from 'redux';
import {
  AttendanceActionTypes,
  AttendanceState,
  AttendanceEntity,
  CheckinActionTypes,
  CheckinState,
  CheckinEntity
} from './attendance.types';
import { GET_ATTENDANCE, CHECKIN, UNCHECKIN, UPDATE_ATTENDANCE_AFTER_CHECKIN } from './attendance.constants';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { initialAttendanceState, initialCheckinState } from './attendance.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';

export const attendanceReducer: Redux.Reducer<AttendanceState> = 
  (attendanceState: AttendanceState = initialAttendanceState,
   action: ReduxAction<AttendanceActionTypes, SimpleResponse<AttendanceEntity>>): AttendanceState => {
  switch (action.type) {
    case `${GET_ATTENDANCE}_FULFILLED`:
      return { ...attendanceState,
        statusCode: action.payload.statusCode,
        attendance: action.payload.body
      };
    case UPDATE_ATTENDANCE_AFTER_CHECKIN:
      return {
        ...attendanceState,
        attendance: action.payload.body
      };
    case REVERT_TO_INITIAL_STATE:
      return initialAttendanceState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialAttendanceState;
    default:
      return attendanceState;
  }
};

export const checkinReducer: Redux.Reducer<CheckinState> = 
(checkinState: CheckinState = initialCheckinState,
 action: ReduxAction<CheckinActionTypes, SimpleResponse<CheckinEntity>>): CheckinState => {
switch (action.type) {
  case `${CHECKIN}_FULFILLED`:
    return { ...checkinState,
      statusCode: action.payload.statusCode,
      msg: action.payload.body.msg,
      entity: action.payload.body.entity,
      entityMemberId: action.payload.body.memberId
    };
  case `${UNCHECKIN}_FULFILLED`:
    return { ...checkinState,
      statusCode: action.payload.statusCode,
      msg: action.payload.body.msg,
      entity: action.payload.body.entity
    };
  case REVERT_TO_INITIAL_STATE:
    return initialCheckinState;
  case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
    return initialCheckinState;
  default:
    return checkinState;
}
};



// WEBPACK FOOTER //
// ./src/attendance/attendance.reducer.tsx